import { useAuth } from "./context/AuthProvider";

export function getToken(){
    return localStorage.getItem("jwt"); 
}

export function isNumeric(value: any) {
    const regex = /^[0-9]+$/;
    return value === '' || regex.test(value);
}

export function isValidName(value: string): boolean {
    //const regex = /^[A-Za-zÀ-ÖØ-öø-ÿ\- ]+$/;
    const regex = /^[a-zA-ZàâäçéèêëîïôöùûüÿñæœÁÀÂÄÇÉÈÊËÎÏÔÖÙÛÜŸÑÆŒ'\- ]+$/;
    return value === '' || regex.test(value);
}